import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ConfirmationService, Message } from 'primeng/api';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { PagamentoDespesa } from 'src/app/admihair/api/dto/pagamento-despesa';
import { PlanoContaEmpresa } from 'src/app/admihair/api/dto/plano-conta-empresa.';
import { TipoPagamento } from 'src/app/admihair/api/dto/tipo-pagamento';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { PagamentoDespesaService } from 'src/app/admihair/service/pagamento-despesa.service';
import { PlanoContaEmpresaService } from 'src/app/admihair/service/plano-conta-empresa.service';
import { TipoPagamentoService } from 'src/app/admihair/service/tipo-pagamento.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';

@Component({
  selector: 'app-pagamento-despesa-pagar',
  templateUrl: './pagamento-despesa-pagar.component.html',
  styleUrls: ['./pagamento-despesa-pagar.component.scss']
})
export class PagamentoDespesaPagarComponent implements OnInit {

  permissaoPagar: boolean = false;
  loading: boolean = true;
  id?: number;
  messages: Message[] = [];
  messagemVisivel: boolean = false;
  empresaSelecionada?: Empresa;
  progressoRequisicao: boolean = false;
  planosContaEmpresa: PlanoContaEmpresa[] = [];
  tiposPagamento: TipoPagamento[] = [];
  pagamentoDespesa?: PagamentoDespesa;
  especificacao?: string;
  liquidado: boolean = false;
  dataAtual: Date = new Date();
  agendamentoPagamento: boolean = false;
  @ViewChild('f') form?: NgForm;

  constructor(private pagamentoDespesaService: PagamentoDespesaService,
    private planoContaEmpresaService: PlanoContaEmpresaService,
    private tipoPagamentoService: TipoPagamentoService,
    private utilStorageService: UtilStorageService,
    private confirmationService: ConfirmationService,
    private activatedRouter: ActivatedRoute, 
    private erroService: ErroService) { }

  ngOnInit(): void {
    this.permissaoPagar = this.verificarPermissao('PERM_PAGAR_PAGAMENTO_DESPESA');
    this.carregarIdAgendamento();
    this.empresaSelecionada = this.utilStorageService.getEmpresa();
    if (this.permissaoPagar) {
      this.carregarTiposPagamento();
    }
  }

  atualizar(){
    this.progressoRequisicao = true;
    if(this.pagamentoDespesa) {
      if(this.agendamentoPagamento){
        this.pagamentoDespesa.status = 2
      } else {
        this.pagamentoDespesa.status = 1
      }
      this.pagamentoDespesa.operador = this.utilStorageService.getUser().usuario.id;
    }
    this.pagamentoDespesaService.atualizar(this.pagamentoDespesa, this.id).subscribe({
      next: (data: PagamentoDespesa) => {
        this.pagamentoDespesa = data;
        this.liquidado = true;
        this.messages = this.erroService.handleSuccess();
        this.messagemVisivel = true;
        this.progressoRequisicao = false;
        this.rolarTela();
      },
      error: (err: any) => {
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.rolarTela();
      }
    });
  }

  carregarAgendamento(){
    this.pagamentoDespesaService.buscarPorId(this.id).subscribe({
      next: (data: PagamentoDespesa) => {
        this.pagamentoDespesa = data;
        console.log(data)
        if(this.pagamentoDespesa.dataFluxo){
          this.pagamentoDespesa.dataFluxo = new Date(this.pagamentoDespesa.dataFluxo + 'T05:00:00Z');
        } else {
          this.pagamentoDespesa.dataFluxo = new Date();
        }
        this.liquidado = this.pagamentoDespesa.status === 1;

        this.loading = false;
        
      },
      error: (err: any) => {
        this.loading = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
      }
    });
  }

  alterarParcelas(valor?: number){
    if(valor){
      this.confirmationService.confirm({
        message: 'Deseja alterar o valor das parcelas seguintes?',
        header: 'Confirmação',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        icon: 'pi pi-info-circle',
        accept: () => {
          
            console.log('aceitou')
        }
    });
    }
  }

  selecionarData(dataSelecionada?: Date){
    if(dataSelecionada && dataSelecionada.getDate() > this.dataAtual.getDate()){
      this.confirmationService.confirm({
        message: 'Data maior que o dia atual. Deseja agendar o pagamento?',
        header: 'Confirmação',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        icon: 'pi pi-info-circle',
        accept: () => {
          this.agendamentoPagamento = true;
        }
      });
    } else {
      this.agendamentoPagamento = false;
    }
  }

  

  carregarTiposPagamento(){
    this.tipoPagamentoService.listarPorEmpresaEOperacaoDespesa(this.empresaSelecionada?.id)
      .subscribe({
        next: (data: TipoPagamento[]) => {
          this.tiposPagamento = data;
          this.carregarPlanosContas();
        },
        error: (err: any) => {
          this.loading = false;
          this.messages = this.erroService.handleErro(err);
          this.messagemVisivel = true;
        }
      })
  }

  carregarPlanosContas(){
    this.planoContaEmpresaService.listarConfiguraveisPorEmpresa(this.empresaSelecionada?.id)
      .subscribe({
        next: (data: PlanoContaEmpresa[]) => {
          this.planosContaEmpresa = data;
          this.carregarAgendamento();
        },
        error: (err: any) => {
          this.loading = false;
          this.messages = this.erroService.handleErro(err);
          this.messagemVisivel = true;
        }
      })
  }

 

 

  carregarIdAgendamento(){
    const idParam = this.activatedRouter.snapshot.paramMap.get('id');
    if(idParam){
      this.id = parseInt(idParam);
    }
  }

  verificarContaFornecedor(id: number): boolean{
    const plano = this.planosContaEmpresa.find(p => p.id === id);
    return plano ? plano.codigo === 22 : false;
  }
  

  verificarPermissao(nome: string): boolean{
    return AuthUtil.verificarPermissao(nome);
  }

  limparFormulario(){
    this.form?.reset(); 
  }

  ocultarMensagem(){
    if(this.messagemVisivel){
      this.messagemVisivel = false;
    }
  }

  rolarTela(){
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

}
